    // license: 'B439F-20I52-CCKJK-S8QRZ',
    import React, { useCallback, useMemo } from 'react';
    import JoditEditor from 'jodit-pro-react';
    import { loadLandingPageFonts } from './landingPageFonts';

    const JoditEditorWrapper = ({ value, onBlur, onChange }) => {
      const editorRef = useCallback((editor) => {
        loadLandingPageFonts().then(async (families) => {
          if (!families.length || editor.isInDestruct || editor.isDestructed) return;
          await editor.waitForReady();
          if (editor.isInDestruct || editor.isDestructed) return;
          // Replace the merged defaults without remounting an editor with unsaved text.
          editor.o.controls.font.list = Object.fromEntries(
            families.map(family => [JSON.stringify(family), family])
          );
          editor.buildToolbar();
        }).catch(error => console.warn('Unable to update landing page editor fonts:', error));
      }, []);

      const config = useMemo(() => ({
        readonly: false,
        height: 250,
        toolbarSticky: false,
        toolbarButtonSize: 'large',
        showCharsCounter: false,
        showWordsCounter: false,
        showXPathInStatusbar: false,
        license: process.env.JODIT_KEY,
        toolbarAdaptive: false,
        allowResizeX: true,
        enter: 'DIV',
        placeholder: 'Start typing...',
        buttons: [
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'superscript',
          'subscript',
          'font',
          'fontsize',
          'brush',
          'background',
          'paragraph',
          '|',
          'align',
          'outdent',
          'indent',
          '|',
          'ul',
          'ol',
          'hr',
          'paragraph',
          'table',
          'symbols',
          '|',
          'link',
          'unlink',
          '|',
          'cut',
          'copy',
          'file',
          'paste',
          'selectall',
          'eraser',
          'undo',
          'redo',
          '|',
        ],
        controls: {
          background: {
            list: {
              '': 'None',
              '#ffffff': 'White',
              '#f8f9fa': 'Light Gray',
              '#000000': 'Black',
              '#ffff00': 'Yellow',
              '#00ffff': 'Cyan',
            },
          },
        },
      }), []);

      return (
        <JoditEditor
          editorRef={editorRef}
          value={value}
          config={config}
          onBlur={onChange}
        />
      );
    };

    export default JoditEditorWrapper;
